<div class="card">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">assignment</i>
    </div>
    <h4 class="card-title" style="cursor: pointer;" (click)="power = !power">
      Search for HDD Link to Master
      <i class="material-icons">toggle_on</i>
    </h4>
  </div>

  <div class="card-body">

    <div *ngIf="power">

      <div class="row">
        <div class="col-md-12">
          <input
            type="text"
            placeholder="Enter Serial Number"
            class="form-control"
            [(ngModel)]="busqueda"
            name="advancedsearchtext"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5 checkbox-radios">
          <div class="form-check">
            <label class="form-check-label">
              <input
                [(ngModel)]="typesearch"
                class="form-check-input"
                type="radio"
                name="typesearch"
                value="SerialNumberMAster"
                checked
              />
              Search by Serial Number of Master Item
              <span class="circle">
                <span class="check"></span>
              </span>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                [(ngModel)]="typesearch"
                class="form-check-input"
                type="radio"
                name="typesearch"
                value="AssetTag"
              />
              Search by Asset Tag of Master Item
              <span class="circle">
                <span class="check"></span>
              </span>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                [(ngModel)]="typesearch"
                class="form-check-input"
                type="radio"
                name="typesearch"
                value="SerialNumber"
              />
              Search for Serial Number of HDD or SDD
              <span class="circle">
                <span class="check"></span>
              </span>
            </label>
          </div>
        </div>
      </div>

      <button *ngIf="typesearch !== undefined" class="btn btn-info" (click)="search()">
        Search
      </button>

      <div class="row">
        <div class="col-md-12">
          <div id="holis123456" style="display: none" class="alert alert-info" role="alert">
            <i style="color: white" class="material-icons"> sync </i> Please wait, searching in progress
          </div>
        </div>
      </div>


      <div class="row" style="display: none" id="resultados">
        <div class="col-md-12" style="line-height: 30px">
          <div class="row">
            <div class="col-md-4">
              <h3>Elements</h3>
            </div>
            <div class="col-md-4" style="position: relative">
              <div style="position: absolute; bottom: 1px; font-size: 1rem">
                Master Items with HDD: <b>{{ contMasterItemHDD }}</b>
              </div>
            </div>
            <div class="col-md-4" style="position: relative">
              <div style="position: absolute; bottom: 1px; font-size: 1rem">
                Master Items without HDD:
                <strong>{{ contMasterItemNOTHDD }}</strong>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1 bg-light">ID</div>
            <div class="col-md-3 bg-light">Serial Number of Master Item</div>
            <div class="col-md-3 bg-light">Asset Tag</div>
            <div class="col-md-3 bg-light">Serial Number</div>

            <div class="col-md-2 bg-light">Delete</div>
          </div>
          <div
            class="row"
            *ngFor="let row of this.responseHdLinkToMaster; index as i"
            style="border-top: 1px solid #eee"
          >
            <div class="col-md-1">
              <strong>{{ i + 1 }}</strong>
            </div>
            <div class="col-md-3">
              {{ row.SerialNumberMAster }}
            </div>

            <div class="col-md-3">
              {{ row.AssetTag }}
            </div>

            <div class="col-md-3" style="font-weight: bold">
              {{ row.SerialNumber }}
            </div>
            <div class="col-md-2">
              <i *ngIf="removing === row.id" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
              <button *ngIf="removing !== row.id" class="btn btn-link btn-danger btn-just-icon" (click)="removeElementFromHDLinkTable(row)" [disabled]="removing !== null">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
